import LegalDocumentPage from "./LegalDocumentPage";

export default function Privacy() {
  return <LegalDocumentPage documentKey="privacy" />;
}
